module.exports = __webpack_public_path__ + "img/Gif.eeeead7f.gif";